module.exports = __webpack_public_path__ + "static/media/Hackathon.0f94dd5f.jpeg";